import { Clapperboard, ArrowBigUp, PartyPopper } from 'lucide-react'
import type { BottomNavItem } from '@/registry/types'

/**
 * Bottom nav / section tabs for Creator Corner:
 *
 *   [Videos] [Suggestions] [Cheers]
 *
 *   - Videos       the creator's videos; watch + drop timestamped comments
 *   - Suggestions  upvotable "what should I improve next" board
 *   - Cheers       positive feedback / celebration wall
 *
 * The video watch route lives under /apps/creator/videos/<id>, so "Videos"
 * stays active there via the prefix match.
 */
export const creatorBottomNav: BottomNavItem[] = [
  {
    id: 'videos',
    label: 'Videos',
    icon: Clapperboard,
    href: '/apps/creator',
    matchPrefixes: ['/apps/creator/videos/'],
  },
  { id: 'suggestions', label: 'Suggestions', icon: ArrowBigUp, href: '/apps/creator/suggestions' },
  { id: 'cheers', label: 'Cheers', icon: PartyPopper, href: '/apps/creator/celebrations' },
]
